import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class Slings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData: '',
            updatingFields: false,
        };
    }

    sigCanvas = {}

    handleSign = () => {
        this.setState({signatureData: this.sigCanvas.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature = this.state.signatureData
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item xs={6}>
                    <FormSelect
                        name="sling_name"
                        label={'Prüfung von'}
                        onChange={selectedOption =>
                            setFieldValue(
                                "sling_name",
                                selectedOption.value
                            )}
                        onBlur={handleBlur}
                        options={[
                            {label: 'Schäkel', value: 'Schäkel'},
                            {label: 'Flaschenzugrollen', value: 'Flaschenzugrollen'},
                            {label: 'Kettenzügen und Seilwinden', value: 'Kettenzügen und Seilwinden'},
                            {label: 'Anschlagpunkten', value: 'Anschlagpunkten'},
                        ]}
                        value={values.sling_name}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_1"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_1}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_1"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_1}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_1"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_1}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_1"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_1}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_1"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_1}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_1"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_1 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_1"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_1 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_1"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_1}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_2"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_2}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_2"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_2}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_2"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_2}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_2"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_2}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_2"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_2}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>

                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_2"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_2 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_2"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_2 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_2"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_2}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_3"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_3}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_3"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_3}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_3"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_3}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_3"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_3}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_3"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_3}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_3"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_3 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_3"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_3 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_3"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_3}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_4"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_4}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_4"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_4}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_4"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_4}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_4"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_4}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_4"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_4}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_4"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_4 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_4"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_4 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_4"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_4}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_5"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_5}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_5"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_5}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_5"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_5}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_5"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_5}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_5"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_5}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_5"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_5 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_5"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_5 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_5"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_5}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_6"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_6}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_6"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_6}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_6"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_6}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_6"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_6}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_6"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_6}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_6"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_6 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_6"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_6 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_6"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_6}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_7"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_7}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_7"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_7}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_7"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_7}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_7"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_7}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_7"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_7}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_7"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_7 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_7"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_7 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_7"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_7}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_8"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_8}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_8"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_8}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_8"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_8}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_8"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_8}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_8"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_8}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_8"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_8 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_8"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_8 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_8"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_8}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_9"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_9}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_9"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_9}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_9"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_9}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_9"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_9}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_9"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_9}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_9"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_9 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_9"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_9 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_9"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_9}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_10"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_10}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_10"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_10}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_10"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_10}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_10"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_10}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_10"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_10}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_10"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_10 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_10"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_10 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_10"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_10}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_11"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_11}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_11"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_11}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_11"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_11}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_11"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_11}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_11"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_11}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_11"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_11 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_11"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_11 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_11"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_11}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={16} alignItems={"center"}>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name={"inventory_number_12"}
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number_12}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number_12"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number_12}
                                inputProps={{
                                    maxLength : 18
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="designation_12"
                                label='Bezeichnung / Größe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.designation_12}
                                inputProps={{
                                    maxLength : 54
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer_12"
                                label='Fabrikat/Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer_12}
                                inputProps={{
                                    maxLength : 34
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type_12"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type_12}
                                inputProps={{
                                    maxLength : 28
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel>Prüfergebnis:</FormLabel>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="inspection_12"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'i.O.',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Fehler',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadio}
                                classNameRadio={classes.formButton}
                                onBlur={handleBlur}
                                value={values.inspection_12 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormRadio
                                name="plaque_12"
                                options={[
                                    {
                                        value : 'yes',
                                        label : 'Plakette angebracht',
                                    },
                                    {
                                        value : 'no',
                                        label : 'Reparatur veranlasst',
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.plaque_12 || ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormField
                                type="text"
                                name="place_12"
                                label='Ort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.place_12}
                                inputProps={{
                                    maxLength : 42
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item md={6} xs={12}>
                    <Grid container xs={12} spacing={8} justify="center" alignItems="center">
                        <Grid item xs={4}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Datum:
                            </Typography>
                        </Grid>
                        <Grid item xs={8} justify="center">
                            <FormDate
                                type="date"
                                name="current_date"
                                // label={i18n.get('cooperations.day_last_appointment')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.current_date}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Nächster Prüftermin:
                            </Typography>
                        </Grid>
                        <Grid item xs={8} justify="center">
                            <FormDate
                                type="date"
                                name="next_date"
                                // label={i18n.get('cooperations.day_last_appointment')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.next_date}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} style={{ border: '1px solid black' }}>
                    <SignatureCanvas
                        penColor='black'
                        canvasProps={{width: 600, height: 200}}
                        ref={(ref) => { this.sigCanvas = ref }}
                        onEnd={this.handleSign}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                        <Grid item xs={6}>&nbsp;</Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            Unterschrift
                        </Grid>
                    </Grid>
                </Grid>

            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButton: {
        marginLeft: '50px'
    },
    formSelection: {
    }
});

export default withStyles(styles)(Slings)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/Slings.js